<div class="modal-header">
  <h3 class="modal-title">
    <strong>AUTENTICAÇÃO PELO OMNI+</strong>
  </h3>
</div>

<div class="modal-body text-center">
  <p class="mb-32">
    Para realizar a <strong>captura da foto do cliente</strong> e finalizar a
    ficha pelo aplicativo <strong>Omni+</strong> siga os seguintes passos:
  </p>

  <ul class="mb-0">
    <li>
      <span class="fa fa-chevron-right"></span>
      <p>Acesse o Omni+ em seu celular.</p>
    </li>
    <li>
      <span class="fa fa-chevron-right"></span>
      <p>Localize a ficha do cliente que está sendo cadastrado.</p>
    </li>
    <li>
      <span class="fa fa-chevron-right"></span>
      <p>Realize a captura da foto do cliente.</p>
    </li>

    <li>
      <span class="fa fa-chevron-right"></span>
      <p>Complete o cadastro pelo aplicativo e finalize a ficha.</p>
    </li>
  </ul>
  
  <p class="text-center mb-0">
    A autenticação do cliente é obrigatória. Sem ela não será possível
    formalizar a proposta. Caso não consiga realizar nenhuma das alternativas, a
    ficha será excluída.
  </p>
</div>

<div class="modal-footer centered">
  <button
    type="button"
    class="btn btn btn-full-orange"
    (click)="closeOnClick()"
  >
    Ok, entendi
  </button>
</div>
